import { render, staticRenderFns } from "./ImageWithAspectRatio.ts.vue?vue&type=template&id=9e189a54&"
import script from "./ImageWithAspectRatio.ts.vue?vue&type=script&lang=ts&"
export * from "./ImageWithAspectRatio.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports